export enum ServiceEnum {
    MonumentPermit = 1,
    Outbound = 2,
}
